import script from "./HelixCreatorTech.vue?vue&type=script&setup=true&lang=js"
export * from "./HelixCreatorTech.vue?vue&type=script&setup=true&lang=js"

import "./HelixCreatorTech.vue?vue&type=style&index=0&id=5e00a765&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e00a765"]])

export default __exports__